export default "__VITE_ASSET__DejyZ_k1__"